import styled from "styled-components";
import { InputComponent } from "../common/InputComponent";

const SearchWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: end;
  width: 100%;
`;

export default function EnterpriseSearchComponent(props: any) {
  const { onChange, searchedText, setSearchedList, onFocus, placeholder } =
    props;

  return (
    <>
      <SearchWrapper>
        <InputComponent
          setSearchedList={setSearchedList}
          value={searchedText}
          onChange={onChange}
          onFocus={onFocus}
          inputType={"text"}
          placeholder={placeholder}
          width={"70vw"}
          height={"5vw"}
          fontSize={"2vw"}
        ></InputComponent>
      </SearchWrapper>
    </>
  );
}
